export const debugIFrame = (xForm, xFrame, xMsg) => {
    if (xFrame == undefined || xFrame == null) {
        xFrame = 'upload_iframe_recent';
    }
    var vForm = document.getElementById(xForm);
    var vFrame = document.getElementById(xFrame);
    var vMsg = document.getElementById(xMsg);
    // show the iframe for troubleshooting purposes
    vFrame.style.visibility = 'visible';
    vFrame.style.height = '200px';
    vFrame.style.width = '200px';
    if (vMsg) {
        vMsg.innerText = '?';
    }
}

// Check iframe result
export const checkIFrame = xFrame => {
    if (xFrame == undefined || xFrame == null) {
        xFrame = 'upload_iframe_recent';
        //xFrame = 'upload_iframe_recent';
    }
    var vFrame = document.getElementById(xFrame);
    //vFrame.inner
    return vFrame.contentDocument || vFrame.contentWindow.document;
}

// Submit an image upload form, using an element to locate the form
export function submitElementToIFrame(xElement, xFrame, xMsg) {
    var xForm = xElement.form.id;
    submitFormToIFrame(xForm, xFrame, xMsg);
}

// Submit an image upload form, using an element to locate the form and PNFK in ids
export function submitElementToIFrameWithPNFK(xElement, xFrame, xMsg) {
    var vForm = xElement.form;
    var vPNFK = vForm.elements['PNFK'].value;
    submitFormToIFrame(vForm.id, xFrame, xMsg + vPNFK);
}

export function resetFrame(xid) {
    // clear the source, preparing for upload
    vFrame.style.height = '5px';
    vFrame.style.width = '5px';
    vFrame.style.visibility = 'hidden';
}

// Submit an image upload form
export const submitFormToIFrame = (xForm, xFrame, xMsg) => {
    if (xFrame == undefined || xFrame == null) {
        xFrame = 'upload_iframe_recent';
    }
    var vForm = document.getElementById(xForm);
    var vFrame = document.getElementById(xFrame);
    var vMsg = document.getElementById(xMsg);
    //var vLocalMsg = vFrom.getElementsByTagName(tagName)
    //var v = xForm.elements['PNFK'].value;
    // clear the source to collapse the iframe
    //resetFrame();
    if (vMsg) {
        vMsg.innerText = 'Uploading...';
    }

    // Use fetch instead of iframe submission to include Authorization header
    const formData = new FormData(vForm);
    
    // Get JWT token from localStorage (same as authInterceptor)
    let authHeader = null;
    try {
        const token = localStorage.getItem('jwt_token');
        if (token) {
            authHeader = 'Bearer ' + token;
        }
    } catch (e) {
        console.warn('Could not get JWT token for upload:', e);
    }

    fetch(vForm.action, {
        method: 'POST',
        body: formData,
        headers: authHeader ? { 'Authorization': authHeader } : {}
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.text();
    })
    .then(text => {
        console.log('Upload response:', text);
        if (vMsg) {
            if (text.includes('Uploaded')) {
                vMsg.innerText = 'Done.';
            } else if (text.includes('Error') || text.includes('Exception')) {
                vMsg.innerText = 'Upload failed.';
                console.error('Upload error:', text);
            } else {
                vMsg.innerText = 'Done.';
            }
        }
        // For backward compatibility, also write to iframe if it exists
        if (vFrame && vFrame.contentDocument) {
            vFrame.contentDocument.body.innerHTML = text;
        }
    })
    .catch(error => {
        console.error('Upload failed:', error);
        if (vMsg) {
            vMsg.innerText = 'Upload failed.';
        }
    })
    .finally(() => {
        setTimeout(() => {
            if (vMsg) {
                vMsg.innerText = '.';
            }
        }, 3000);
    });
}
